import { apiClient } from '../client';
import type { ApiResponse } from '../types';
import { unwrapResponse } from '../types';
import type {
  Department,
  CreateDepartmentInput,
  UpdateDepartmentInput,
  PaginatedResponse,
} from '@coi-live/shared-types';

interface ListDepartmentsParams {
  limit?: number;
  cursor?: string;
}

function buildQueryString(params: ListDepartmentsParams): string {
  const searchParams = new URLSearchParams();
  if (params.limit) searchParams.set('limit', String(params.limit));
  if (params.cursor) searchParams.set('cursor', params.cursor);
  const qs = searchParams.toString();
  return qs ? `?${qs}` : '';
}

export const departmentsService = {
  async list(params: ListDepartmentsParams = {}): Promise<PaginatedResponse<Department>> {
    const url = `/departments${buildQueryString(params)}`;
    const { data } = await apiClient.get<ApiResponse<PaginatedResponse<Department>>>(url);
    return unwrapResponse(data);
  },

  async get(id: string): Promise<Department> {
    const { data } = await apiClient.get<ApiResponse<Department>>(`/departments/${id}`);
    return unwrapResponse(data);
  },

  async create(input: CreateDepartmentInput): Promise<Department> {
    const { data } = await apiClient.post<ApiResponse<Department>>('/departments', input);
    return unwrapResponse(data);
  },

  async update(id: string, input: UpdateDepartmentInput): Promise<Department> {
    const { data } = await apiClient.put<ApiResponse<Department>>(`/departments/${id}`, input);
    return unwrapResponse(data);
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/departments/${id}`);
  },
};
